import { CheckedCsvInviteUser, CsvInviteUser, UserInvitationResult } from '../../../../store/auth/auth'

export interface BulkInvitationContextState {
  csv: {
    fileContent: string | null
    clientSideVerificationLoading: boolean
    clientSideVerificationCompleted: boolean
    clientSideVerificationError: string | null
    serverSideVerificationLoading: boolean
    serverSideVerificationCompleted: boolean
    serverSideVerificationErrors: string[]
  }
  invite: {
    isInvitationLoading: boolean
    processedInvitationCount: number
    results: UserInvitationResult[]
    completed: boolean
  }
  users: CsvInviteUser[] | CheckedCsvInviteUser[]
}

export const initialBulkInviteContextState: BulkInvitationContextState = {
  csv: {
    fileContent: null,
    clientSideVerificationLoading: false,
    clientSideVerificationCompleted: false,
    clientSideVerificationError: null,
    serverSideVerificationLoading: false,
    serverSideVerificationCompleted: false,
    serverSideVerificationErrors: [],
  },
  invite: {
    isInvitationLoading: false,
    processedInvitationCount: 0,
    results: [],
    completed: false,
  },
  users: [],
}
